import { render } from "./recordListDialog.vue?vue&type=template&id=7c2c9b3f"
import script from "./recordListDialog.vue?vue&type=script&lang=js"
export * from "./recordListDialog.vue?vue&type=script&lang=js"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__